import { functions } from "../../firebase";
export const deleteProduct = async (params: { communityId: string; productId: string }): Promise<void> => {
  await functions.httpsCallable("deleteShopProduct")(params);
};
